import React from 'react'
import PropTypes from 'prop-types'

import { createRecipeUrl } from '../../../../../helpers/url/url'
import * as S from './ingredient-list-styled'

const IngredientList = ({ ingredients, recipeSlugLinks }) => (
  <S.List>
    {ingredients.map((ing, i) => (

      <S.ListItem key={i}>

        <S.Item>
          {renderIngredientItemName(ing, recipeSlugLinks)}
        </S.Item>

        <S.Qty>
          {ing.qty}
        </S.Qty>

      </S.ListItem>
    ))}
  </S.List>
)

const renderIngredientItemName = ({ item, url, slugUrlIndex }, recipeSlugLinks ) => {
  if (url) {
    // if there is a regular url (affiliate link),
    // render link to open in new window
    return (
      <S.A
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item}
        &nbsp;<S.NewWindowIcon />
      </S.A>
    )
  } else if (Number.isInteger(slugUrlIndex) && recipeSlugLinks[slugUrlIndex] && recipeSlugLinks[slugUrlIndex].slug) {
    // if item points to existing recipe,
    // render link to recipe in current window
    const slug = recipeSlugLinks[slugUrlIndex].slug;
    return (
      <>
        {item}
        &nbsp;
        <S.A href={createRecipeUrl(slug)}>
          (go to recipe)
        </S.A>
      </>
    )
  }
  // else return the item name (not hyperlinked)
  return item;
}

IngredientList.propTypes = {
  ingredients: PropTypes.array.isRequired,
  recipeSlugLinks: PropTypes.array.isRequired,
}

export { IngredientList }